import Schema from 'AppReact/schema';
import { priority, group, property, inspection_tag, inspectionTemplate } from 'types';

export default {
  inspectionTemplates: Schema(inspectionTemplate, 'array', { defaultValue: [] }),
  properties: Schema(property, 'array', { defaultValue: [] }),
  groups: Schema(group, 'array', { defaultValue: [] }),
  priorities: Schema(priority, 'array', { defaultValue: [] }),
  inspectionTags: Schema(inspection_tag, 'array', { defaultValue: [] }),
  selectedPropertyIds: Schema('integer',  'array', { defaultValue: [] }),
  selectedGroupIds: Schema('integer', 'array', { defaultValue: [] }),
  selectedTab: Schema('string', 'primitive', { defaultValue: 'active_templates' }),
  visibleTagInput: Schema('boolean', 'primitive', { defaultValue: false }),
}
